import {AppState} from '../app.state';
import {createSelector} from "@ngrx/store";

export const selectMarketplaceState = (state: AppState) => state.marketplace;

export const selectMarketplaceData = createSelector(
    selectMarketplaceState,
    (state) => state.data
);

export const selectMarketplaceFilteredProducts = createSelector(
    selectMarketplaceState,
    (state) => state.filteredProducts
);

export const selectMarketplaceError = createSelector(
    selectMarketplaceState,
    (state) => state.error
);

export const selectMarketplaceIsLoading = createSelector(
    selectMarketplaceState,
    (state) => state.isLoading
);

export const selectMarketplaceAvailableFilters = createSelector(
    selectMarketplaceState,
    (state) => state.availableFilters
);

export const selectMarketplaceFilters = createSelector(
    selectMarketplaceState,
    (state) => state.filters
);

export const selectMarketplaceShowFilters = createSelector(
    selectMarketplaceState,
    (state) => state.showFilters
);

export const selectMarketplaceSort = createSelector(
    selectMarketplaceState,
    (state) => state.sort
);

export const selectMarketplaceIsFilteredProductsEmpty = createSelector(
    selectMarketplaceFilteredProducts,
    (filteredProducts) => {
        return filteredProducts.featured.length === 0 &&
            filteredProducts.bundle.length === 0 &&
            filteredProducts.subscription.length === 0 &&
            filteredProducts.oneShotPurchase.length === 0 &&
            Object.keys(filteredProducts.categories).length === 0;
    }
);
